export default {"src":"/_next/static/media/grs.ea846a63.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};